import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useMemo } from "react";
import TopBanner from "./TopBanner";
import Navbar from "./Navbar";
import Footer from "./Footer";
import StickyMobileCTA from "./StickyMobileCTA";

import { useLocalBusinessSchema } from "./SeoHead";

const ORG_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Nettoyage Expert",
  "alternateName": "Nettoyage Expert Suisse Romande",
  "description": "Entreprise de nettoyage professionnel en Suisse romande",
  "url": "https://www.nettoyage-expert.ch",
  "logo": "https://www.nettoyage-expert.ch/logo-black.png",
  "telephone": "+41245391033",
  "email": "info@nettoyage-expert.ch",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Rue Jean-André Venel 4",
    "addressLocality": "Yverdon-les-Bains",
    "postalCode": "1400",
    "addressRegion": "VD",
    "addressCountry": "CH"
  },
  "sameAs": ["https://g.page/r/CTTcLCQur3ryEAE", "https://wa.me/41786202854"],
  "knowsAbout": [
    "nettoyage canapé", "nettoyage matelas", "nettoyage moquette",
    "nettoyage tapis", "nettoyage vitres", "nettoyage terrasse",
    "nettoyage façade", "nettoyage toiture", "nettoyage panneaux solaires",
    "nettoyage bureaux", "nettoyage hôtels", "nettoyage fin de chantier"
  ]
};

export default function PublicLayout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  const localBusiness = useLocalBusinessSchema();

  const enrichedLocalBusiness = useMemo(() => ({
    ...localBusiness,
    "geo": { "@type": "GeoCoordinates", "latitude": 46.7785, "longitude": 6.6411 },
    "openingHoursSpecification": [
      { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"], "opens": "07:00", "closes": "19:00" },
      { "@type": "OpeningHoursSpecification", "dayOfWeek": "Saturday", "opens": "08:00", "closes": "17:00" }
    ],
    "sameAs": ["https://g.page/r/CTTcLCQur3ryEAE", "https://wa.me/41786202854"],
  }), [localBusiness]);

  const schemas = [ORG_SCHEMA, enrichedLocalBusiness];

  return (
    <div className="flex flex-col min-h-screen" data-testid="public-layout">
      {schemas.map((s, i) => (
        <script key={`gs-${i}`} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(s) }} />
      ))}
      <TopBanner />
      <Navbar />
      <main className="flex-1 pb-16 sm:pb-0">
        <Outlet />
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}
